module.exports = __webpack_public_path__ + "4150c033e7143f3fa98b12b290fee6d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/TrainingGroups/training-groups-intro.jpg
// module id = 575
// module chunks = 0